var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-bottom-user-notification"},[_c('local-notification-list'),_vm._v(" "),_c('shipment-suspend-notification',{attrs:{"brandEnglishName":_vm.brandEnglishName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }